var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "keyboard" }, [
    _c("div", { staticClass: "first-row" }, [
      _c(
        "a",
        {
          staticClass: "up-key",
          on: {
            click: function($event) {
              return _vm.$emit("up-click")
            }
          }
        },
        [_vm._v("\n            ∧\n        ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "second-row" }, [
      _c(
        "a",
        {
          staticClass: "left-key",
          on: {
            click: function($event) {
              return _vm.$emit("left-click")
            }
          }
        },
        [_vm._v("\n            <\n        ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "right-key",
          on: {
            click: function($event) {
              return _vm.$emit("right-click")
            }
          }
        },
        [_vm._v("\n            >\n        ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "third-row" }, [
      _c(
        "a",
        {
          staticClass: "down-key",
          on: {
            click: function($event) {
              return _vm.$emit("down-click")
            }
          }
        },
        [_vm._v("\n            ∨\n        ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }